// The provider thread list's cache entry, described in a LEAF module rather than beside the hook
// that queries it.
//
// NOTHING RUNTIME IS IMPORTED HERE. The key is what a HOST needs in order to invalidate the list —
// the app's Clinicians route does exactly that
// (src/pages/consumer/messages/useEnsureProviderIdentity.ts) — and a shared constant should be
// reachable on its own rather than through the hook module that happens to query with it. That is
// the whole claim: a naming boundary, held by `exports` in package.json and by the hook
// re-exporting from here.
//
// ⚠ IT SAVES NO BYTES TODAY, so do not defend it as a bundle split. The app's messages shell
// statically imports `@internal/messages/unread-dot` (src/pages/messages-shell.tsx), which imports
// `hooks/useProviderThreads`, so that hook's import tree — the host context, `lib/unifiedThread`,
// the provider types — already ships in the chunk every authenticated member downloads, whichever
// module a host reaches the key through.

/**
 * The provider list gets its OWN cache entry rather than joining `["threads"]`: that key is the
 * legacy Carrot payload, shared by the app's nav unread dot, its home page and the Carrot half of
 * /messages.
 */
export const PROVIDER_THREADS_CACHE_KEY = ["messages", "healthie", "threads"] as const

/** What that entry holds — re-exported here so a host reading it needs no second import. */
export type { ProviderThreadList } from "../providerMessagingTypes"
